import { render } from "./IconExclamation.vue?vue&type=template&id=caacace8"
import script from "./IconExclamation.vue?vue&type=script&lang=js"
export * from "./IconExclamation.vue?vue&type=script&lang=js"
script.render = render

export default script